module.exports = __webpack_public_path__ + "static/media/menu-en-1.9e968c8c.svg";